import { render, staticRenderFns } from "./OrderPrintHb.vue?vue&type=template&id=504a06fd&scoped=true&"
import script from "./OrderPrintHb.vue?vue&type=script&lang=js&"
export * from "./OrderPrintHb.vue?vue&type=script&lang=js&"
import style0 from "./OrderPrintHb.vue?vue&type=style&index=0&id=504a06fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a06fd",
  null
  
)

export default component.exports